module.exports = __webpack_public_path__ + "img/E.da0bab8d.png";